import CalendarMain from "./Calendar";

const CalendarConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/calendar',
            element: <CalendarMain />,
        }
    ],
}

export default CalendarConfig;